const settings = {
  // baseApiUrl: "https://staging-api.vaix.ai",
  baseApiUrl: "https://api.vaix.ai",
  operator: "casino_demo",
  vaixClientId: "casino_demo",
  // username: "vaix",
  // password: "617cfa43c6ba34a97a77cf9ae19536de0f82d26bca0740c805e475c3eba135bc",
  widgetSettingsType: "widget_settings",
  // widgetSettingsType: "development_widget_settings",
  excludeRecentFrom: ["recommended", "combined"],
  shuffledSwimlanes: ["trending", "favoriteStudio"],
  components: {
    sliderItem: {
      magnifyOnHover: true,
      showPlayBtnOnHover: true,
      tags: [],
    },
    slider: {
      moreBtnHover: true,
    },
    toggleSmartSearch: {
      placeholder: "Try Smart Search",
    },
  },
};

export default settings;
